module.exports = __webpack_public_path__ + "assets/834eeed3b0caa6319536ea3697ec2099.mp4";